import { EbenGenericError } from "./eben-error.model";

export enum ProcessErrorKind {
  Generic = "Generic",
  Start = "Start",
  InstanceNotFound = "InstanceNotFound",
  InstanceCancel = "InstanceCancel",
}

export class ProcessGenericError extends EbenGenericError {
  constructor(public error: Error,
    public processInstanceId: string,
    public readonly kind: ProcessErrorKind = ProcessErrorKind.Generic
  ) {
    super();
  }
}

export class ProcessStartError extends ProcessGenericError {
  constructor(public error: Error, public processDefinitionId: string) {
    super(error, processDefinitionId, ProcessErrorKind.Start);
  }
}

export class ProcessInstanceNotFoundError extends ProcessGenericError {
  constructor(public error: Error, public processInstanceId: string) {
    super(error, processInstanceId, ProcessErrorKind.InstanceNotFound);
  }
}

export class ProcessInstanceCancelError extends ProcessGenericError {
  constructor(public error: Error, public processInstanceId: string) {
    super(error, processInstanceId, ProcessErrorKind.InstanceCancel);
  }
}
